import { useEffect, useState } from 'react'
import { Icon } from '@iconify/react'
import TableData from '../../../../components/ui/TableData'

import useGetErrors from '../hooks/useGetErrors'
import { Button } from '../../../../components/ui/legacy'
import { PAGE_SIZE } from '../../../../data/queryFactories'
import ErrorDetailModal from './ErrorDetailModal'
import { PATH } from '../../../../data/router_path'
import { showErrorToast } from '../../../../utils/showToast'
// const FAKE_ERROR_UUID = 'efa0c8ae-64e5-436f-aabc-cec9c825e9cd'
export default function ErrorReportDataTable() {
  const [activeErrorReport, setActiveErrorReport] = useState(null)

  const {
    data: {
      pageNumber = 1,
      pageSize = PAGE_SIZE,
      errors = [],
      totalItems = 0,
    } = {},
  } = useGetErrors()

  const columnMapping = [
    { key: 'studentId', value: 'Mã tài khoản' },
    { key: 'content', value: 'Nội dung báo lỗi' },
    { key: 'createdAt', value: 'Ngày báo lỗi' },
    { key: 'device', value: 'Thiết bị' },
    { key: 'status', value: 'Trạng thái' },
    { key: 'uuid', value: 'Mã báo lỗi' },
  ]

  const columnWidths = {
    studentId: 'w-[15vw]',
    content: 'w-[25vw]',
    createdAt: 'w-[15vw]',
    device: 'w-[15vw]',
    status: 'w-[15vw]',
    uuid: 'w-[15vw]',
  }

  const actionButtons = [
    {
      title: 'Chi tiết & hành động',
      icon: <Icon icon="ph:info-bold" className="text-2xl" />,
      onClick: (row) => {
        showErrorToast({ message: 'Sẽ cập nhật trong phiên bản mới' })
      },
      label: 'Xem',
    },
  ]

  const detailViewFunction = (row) => {
    setActiveErrorReport(row.uuid)
  }

  return (
    <>
      <TableData
        data={errors}
        columnMapping={columnMapping}
        columnWidths={columnWidths}
        actionButtons={actionButtons}
        paginationEnabled={true}
        dataType="báo lỗi"
        currentPage={pageNumber}
        totalPages={Math.floor(totalItems / pageSize)}
        pageSize={pageSize}
        totalItems={totalItems}
        detailView={detailViewFunction}
        path={PATH.SYSTEM.ERRORS_REPORT.LIST}
        extraFunctions={[
          <Button
            variant={'plain'}
            onClickHandler={() =>
              showErrorToast({ message: 'Sẽ cập nhật trong phiên bản mới' })
            }
          >
            Phản hồi
          </Button>,
          <Button
            variant={'super'}
            onClickHandler={() =>
              showErrorToast({ message: 'Sẽ cập nhật trong phiên bản mới' })
            }
          >
            Từ chối tất cả báo cáo
          </Button>,
        ]}
      />
      {activeErrorReport && (
        <ErrorDetailModal
          uuid={activeErrorReport}
          closeHandler={() => {
            setActiveErrorReport(null)
          }}
        />
      )}
    </>
  )
}
